// extracted by mini-css-extract-plugin
export var Card = "OngletCartesSection-module--Card--00ad4";
export var Header = "OngletCartesSection-module--Header--376e7";
export var SpanStyle = "OngletCartesSection-module--SpanStyle--13561";
export var active = "OngletCartesSection-module--active--efe49";
export var bottomContent = "OngletCartesSection-module--bottomContent--8fae3";
export var capitalize = "OngletCartesSection-module--capitalize--560a3";
export var cardsContainer = "OngletCartesSection-module--cardsContainer--5d4df";
export var fs14 = "OngletCartesSection-module--fs-14--43963";
export var fs16 = "OngletCartesSection-module--fs-16--36b46";
export var fs20 = "OngletCartesSection-module--fs-20--50a0a";
export var fs24 = "OngletCartesSection-module--fs-24--f514d";
export var fs32 = "OngletCartesSection-module--fs-32--9a620";
export var fs40 = "OngletCartesSection-module--fs-40--c2e99";
export var fsItalic = "OngletCartesSection-module--fs-italic--9c9de";
export var fsLg = "OngletCartesSection-module--fs-lg--c5008";
export var fsMd = "OngletCartesSection-module--fs-md--aeaa7";
export var fsNormal = "OngletCartesSection-module--fs-normal--9a9a0";
export var fsSm = "OngletCartesSection-module--fs-sm--5d226";
export var fsXl = "OngletCartesSection-module--fs-xl--6032d";
export var fsXs = "OngletCartesSection-module--fs-xs--9ef11";
export var fsXxl = "OngletCartesSection-module--fs-xxl--4f020";
export var fsXxs = "OngletCartesSection-module--fs-xxs--e60d7";
export var fwBold = "OngletCartesSection-module--fw-bold--d72a6";
export var fwMedium = "OngletCartesSection-module--fw-medium--df7b3";
export var fwNormal = "OngletCartesSection-module--fw-normal--1f58c";
export var gotham_bold = "OngletCartesSection-module--gotham_bold--6636e";
export var gotham_bold_italic = "OngletCartesSection-module--gotham_bold_italic--94b89";
export var gotham_book = "OngletCartesSection-module--gotham_book--b73a4";
export var gotham_book_italic = "OngletCartesSection-module--gotham_book_italic--ad74a";
export var img = "OngletCartesSection-module--img--8e9f4";
export var jobHeader = "OngletCartesSection-module--jobHeader--89ac1";
export var lienUnstyled = "OngletCartesSection-module--lienUnstyled--3b530";
export var lowercase = "OngletCartesSection-module--lowercase--d256d";
export var overlay = "OngletCartesSection-module--overlay--69a55";
export var sectionStyle = "OngletCartesSection-module--sectionStyle--10948";
export var showOverlay = "OngletCartesSection-module--showOverlay--4afe7";
export var tabButton = "OngletCartesSection-module--tabButton--1393a";
export var tabButtons = "OngletCartesSection-module--tabButtons--773ee";
export var tabbtnBg = "OngletCartesSection-module--tabbtnBg--9ce80";
export var uppercase = "OngletCartesSection-module--uppercase--c3a48";